export default "__VITE_ASSET__BgOTJH7I__"